export const setDelayForSubsSkip = (callback: (arg: boolean) => void) => {
  let clearTimeOutFlag = true

  const delayTimeoutId = setTimeout(() => {
    callback(false)
    clearTimeOutFlag = false
  }, 2000)

  return () => {
    if (clearTimeOutFlag) {
      clearTimeout(delayTimeoutId)
    }
  }
}
